export default {
      id: "arrow-top-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#arrow-top",
      toString: function () {
        return this.url;
      }
    }